import type { UsernameVerificationCredentials } from "@/modules/auth/common/types";
import { usernameVerificationValidationSchema } from "@/modules/auth/validations/validationSchema";
import { Button } from "@ab.uitools/ui-library/components/Button";
import { FormContainer } from "@ab.uitools/ui-library/components/FormContainer";
import type { TFormData } from "@ab.uitools/ui-library/types/globalTypes";
import { useTranslation } from "react-i18next";

import { UsernameVerificationFormFields } from "./UsernameVerificationFormFields";

interface Props {
  onSubmit: (val: UsernameVerificationCredentials) => void;
  isLoading: boolean;
}

const initialValues = {
  username: "",
};

export const UsernameVerificationForm = ({ onSubmit, isLoading }: Props) => {
  const { t } = useTranslation();

  const handleSubmit = (val: TFormData, isDirty: boolean) => {
    if (isDirty) {
      onSubmit({ ...val } as UsernameVerificationCredentials);
    }
  };

  return (
    <div>
      <FormContainer
        className="full-width"
        onSubmit={(data, formState) => handleSubmit(data, formState.isDirty)}
        mode="onBlur"
        reValidateMode="onBlur"
        validationScheme={usernameVerificationValidationSchema({ t })}
        initialValues={initialValues}
        shouldFocusError
      >
        <UsernameVerificationFormFields/>
        <Button
          isLoading={isLoading}
          className="full-width mt-32"
          buttonActionType="submit"
          data-testid="reset-password-username-verification"
          data-ga-id="reset-password-username-verification"
          data-ga-action="Reset password, username verification"
          buttonText={t("general.confirm")}
        />
      </FormContainer>
    </div>
  );
};
